import { memo } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

const FRONT = 'https://wver.sprintstaticdata.com/v230/static/front/img';
const ADMIN = 'https://wver.sprintstaticdata.com/v230/static/admin/img';

function findByNat(sub, nat) {
  return sub.find((s) => s.nat === nat);
}
function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}
function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}
function bookOf(exposures, nat) {
  return roundBook(exposures?.[nat] ?? 0);
}
function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

// The Trap bet table: Player A/B (back-lay), LOW/HIGH (seven-up-down), JQK
// (J/Q/K back-lay), phir trap-number bg image. book-black hamesha. sub:
// subtype trap (A/B), highlow (active card ke odds[] High/Low), jqk (odds[] JQK).
const BetTableTrap = memo(function BetTableTrap({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});

  const playerA = findByNat(sub, 'Player A');
  const playerB = findByNat(sub, 'Player B');

  // active card ka parent = jisme LIVE odds ho (koi bhi odds.b > 0); warna
  // pehla non-suspended, warna pehla with odds. (14 cards me sirf active ka odds live)
  const hlParent = sub.find((s) => s.subtype === 'highlow' && !isSusp(s) && s.odds?.some((o) => (o.b ?? 0) > 0))
    || sub.find((s) => s.subtype === 'highlow' && s.odds?.some((o) => (o.b ?? 0) > 0))
    || sub.find((s) => s.subtype === 'highlow' && s.odds?.length > 0 && !isSusp(s))
    || sub.find((s) => s.subtype === 'highlow' && s.odds?.length > 0);
  const hlOdds = hlParent?.odds || [];
  const highEntry = hlOdds.find((o) => o.nat === 'High');
  const lowEntry = hlOdds.find((o) => o.nat === 'Low');
  // Open only while the feed says so: at the timer's end the card goes
  // gstatus SUSPENDED but its odds stay quoted (High/Low 2, JQK 4.01) — reading
  // the odds alone never locked the box (live feed, 2026-10-09).
  const hlOpen = !isSusp(hlParent) && hlOdds.some((o) => (o.b ?? 0) > 0);

  const jqkParent = sub.find((s) => s.subtype === 'jqk' && !isSusp(s) && s.odds?.some((o) => (o.b ?? 0) > 0))
    || sub.find((s) => s.subtype === 'jqk' && s.odds?.some((o) => (o.b ?? 0) > 0))
    || sub.find((s) => s.subtype === 'jqk' && s.odds?.length > 0 && !isSusp(s))
    || sub.find((s) => s.subtype === 'jqk' && s.odds?.length > 0);
  const jqkOdds = jqkParent?.odds || [];
  const jqkEntry = jqkOdds.find((o) => o.nat === 'JQK');
  const jqkOpen = !isSusp(jqkParent) && (jqkEntry?.b ?? 0) > 0;

  const bA = bookOf(exposures, 'Player A');
  const bB = bookOf(exposures, 'Player B');
  // Side books are per card: bets are stored "Card 3 Low" / "Card 5 JQK".
  const bLow = bookOf(exposures, `${hlParent?.nat} Low`);
  const bHigh = bookOf(exposures, `${hlParent?.nat} High`);
  const bJqk = bookOf(exposures, `${jqkParent?.nat} JQK`);

  function PlayerBox({ label, item, book, side }) {
    return (
      <div className={side}>
        <div className="casino-box-row">
          <div className="casino-nation-name">
            <b>{label}</b>
            {' '}
            <div className="float-right"><span className={`mr-2 ${bookCls(book)}`}>{fmtBook(book)}</span></div>
          </div>
          {' '}
          <div className="casino-bl-box">
            <div className={`back casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'back', item.b, item)}>
              <span className="casino-box-odd">{item?.b ?? 0}</span>
            </div>
            {' '}
            <div className={`lay casino-bl-box-item${suspCls(item)}`} onClick={isSusp(item) ? undefined : () => handleBet(item.sid, 'lay', item.l, item)}>
              <span className="casino-box-odd">{item?.l ?? 0}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Row 1: Player A vs Player B */}
      <div className="teen1daycasino-container">
        <PlayerBox label="Player A" item={playerA} book={bA} side="teen1dayleft" />
        {' '}
        <div className="teen1daycenter"></div>
        {' '}
        <PlayerBox label="Player B" item={playerB} book={bB} side="teen1dayright" />
      </div>
      {' '}
      {/* Row 2: LOW/HIGH + JQK */}
      <div className="teen1daycasino-container">
        <div className="teen1dayleft">
          <div className="seven-up-down-box">
            <div
              className={`up-box${hlOpen ? '' : ' suspended'}`}
              onClick={!hlOpen ? undefined : () => handleBet(hlParent.sid, 'back', lowEntry?.b ?? 0, { ...hlParent, nat: 'Low', b: lowEntry?.b ?? 0, selectedOddsSid: lowEntry?.sid })}
            >
              <div className={`up-down-book ${bookCls(bLow)}`}>{fmtBook(bLow)}</div>
              {' '}
              <div className="text-right">
                <div className="up-down-odds">{lowEntry?.b ?? 0}</div>
                {' '}
                <span>LOW</span>
              </div>
            </div>
            {' '}
            <div
              className={`down-box${hlOpen ? '' : ' suspended'}`}
              onClick={!hlOpen ? undefined : () => handleBet(hlParent.sid, 'back', highEntry?.b ?? 0, { ...hlParent, nat: 'High', b: highEntry?.b ?? 0, selectedOddsSid: highEntry?.sid })}
            >
              <div className="text-left">
                <div className="up-down-odds">{highEntry?.b ?? 0}</div>
                {' '}
                <span>HIGH</span>
              </div>
              {' '}
              <div className={`up-down-book ${bookCls(bHigh)}`}>{fmtBook(bHigh)}</div>
            </div>
            {' '}
            <div className="seven-box">
              <img src={`${FRONT}/trape-seven.png`} />
            </div>
          </div>
        </div>
        {' '}
        <div className="teen1daycenter"></div>
        {' '}
        <div className="teen1dayright">
          <div className="casino-box-row jqk-box">
            <div className="casino-nation-name">
              <span>
                <img src={`${FRONT}/cards/J.png`} />
                {' '}
                <img src={`${FRONT}/cards/Q.png`} />
                {' '}
                <img src={`${FRONT}/cards/K.png`} />
              </span>
              {' '}
              <div className="float-right"><span className={`mr-2 ${bookCls(bJqk)}`}>{fmtBook(bJqk)}</span></div>
            </div>
            {' '}
            <div className="casino-bl-box">
              <div
                className={`back casino-bl-box-item${jqkOpen ? '' : ' suspended'}`}
                onClick={!jqkOpen ? undefined : () => handleBet(jqkParent.sid, 'back', jqkEntry?.b ?? 0, { ...jqkParent, nat: 'JQK', b: jqkEntry?.b ?? 0, selectedOddsSid: jqkEntry?.sid })}
              >
                <span className="casino-box-odd">{jqkEntry?.b ?? 0}</span>
              </div>
              {' '}
              <div
                className={`lay casino-bl-box-item${jqkOpen ? '' : ' suspended'}`}
                onClick={!jqkOpen ? undefined : () => handleBet(jqkParent.sid, 'lay', jqkEntry?.l ?? 0, { ...jqkParent, nat: 'JQK', l: jqkEntry?.l ?? 0, selectedOddsSid: jqkEntry?.sid })}
              >
                <span className="casino-box-odd">{jqkEntry?.l ?? 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {' '}
      {/* Trap number bg */}
      <div className="teen1daycasino-container trap-number">
        <img src={`${ADMIN}/trap-number-bg.jpg`} className="img-fluid" />
      </div>
    </>
  );
});

export default BetTableTrap;
